import type * as AmplifyAuth from 'aws-amplify/auth';

export type NewsAuth = typeof AmplifyAuth;

let loading: Promise<NewsAuth> | undefined;

/**
 * Loads and configures Amplify Auth on first use, and resolves to its API.
 *
 * WHY: Amplify is the largest dependency on news pages (~117 KiB raw), yet a
 * signed-out visitor only needs it once they open a login or sign-up dialog.
 * Imported statically, it was in every news page's preloaded scripts and
 * competed with the first paint. Every Amplify call goes through this function,
 * so it is always configured before use; the import and the configuration
 * happen once and are shared by concurrent callers.
 */
export const loadNewsAuth = (): Promise<NewsAuth> => {
	if (!loading) {
		loading = Promise.all([
			import('#lib/websites/news/utils/configureNewsAmplify/configureNewsAmplify.js'),
			import('aws-amplify/auth'),
		]).then(([{ configureNewsAmplify }, auth]) => {
			configureNewsAmplify();

			return auth;
		});

		// A failed chunk load (flaky network, a deploy mid-session) must not be
		// cached, or every later sign-in attempt would fail without retrying.
		loading.catch(() => {
			loading = undefined;
		});
	}

	return loading;
};
